import React from 'react';

import cs from 'classnames';

import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';

const SelectionActionBar = ({
  totalSelected,
  isAnySelectedEnrolled,
  isAnySelectedNotEnrolled,
  onClearSelection,
  onEnroll,
  onUnenroll,
  isEnrollLoading,
  hidden
}) => {
  return (
    <div
      className={cs(
        'fixed bottom-[123px] h-[48px]',
        'flex items-center justify-between gap-4 px-4 py-3',
        'z-40 rounded-lg bg-neutral-700',
        'transition-all duration-300 ease-out',
        totalSelected > 0 && !hidden ? 'opacity-100 translate-y-0' : 'translate-y-[200%] opacity-0'
      )}
      style={{
        left: 'calc(320px + 40px + 24px + (100vw - 1168px) / 2)',
        right: 'calc(24px + (100vw - 1168px) / 2)'
      }}>
      <div className="flex items-center gap-3">
        <Icon
          icon="close-linear"
          color="white"
          size={16}
          onClick={onClearSelection}
          className="cursor-pointer rounded hover:opacity-70"
        />
        <span className="text-sm font-500 text-white">
          {totalSelected} {totalSelected === 1 ? 'user' : 'users'} selected
        </span>
      </div>
      <div
        className={cs(
          'flex origin-center items-center gap-3 opacity-100',
          'transition-transform duration-300 ease-out will-change-transform',
          {
            'scale-0 delay-300': totalSelected === 0,
            'scale-100': totalSelected > 0
          }
        )}>
        {isAnySelectedNotEnrolled && (
          <Button
            text="Enroll"
            color="primary"
            size="xs"
            icon="patient-add-mono"
            onClick={onEnroll}
            isLoading={isEnrollLoading}
          />
        )}
        {isAnySelectedEnrolled && (
          <Button
            text="Un-enroll"
            color="danger"
            size="small"
            icon="user-remove-mono"
            onClick={onUnenroll}
          />
        )}
      </div>
    </div>
  );
};

export default SelectionActionBar;
